import { AdminConsultaProvider } from "./context/AdminConsultaContext";
import { AnuncioProvider } from "./context/AnuncioContext";
import { BrowserRouter } from "react-router-dom";
import { CallCenterProvider } from "./context/CallCenterContext";
import { CatalogoProvider } from "./context/CatalogoContext";
import { ColaboradorProvider } from "./context/ColaboradorContext";
import { CuponProvider } from "./context/CuponContext";
import DateFnsUtils from "@date-io/date-fns";
import { EmpresaProvider } from "./context/EmpresaContext";
import { EspecialidadProvider } from "./context/EspecialidadContext";
import { FolioProvider } from "./context/FolioContext";
import { LayoutProvider } from "./context/LayoutContext";
import { LoginProvider } from "./context/LoginContext";
import MeditocPage from "./components/MeditocPage";
import { MisConsultasProvider } from "./context/MisConsultasContext";
import { MotivoConsultaProvider } from "./context/MotivoConsultaContext";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { PerfilProvider } from "./context/PerfilContext";
import { ProductoProvider } from "./context/ProductoContext";
import { ReporteDoctorProvider } from "./context/ReporteDoctorContext";
import { ReporteVentaProvider } from "./context/ReporteVentaContext";
import { RequestProvider } from "./context/RequestContext";
import { SistemaProvider } from "./context/SistemaContext";
import { StyleProvider } from "./context/StyleContext";
import { ThemeProvider } from "@material-ui/styles";
import { TokenProvider } from "./context/TokenContext";
import { UsuarioProvider } from "./context/UsuarioContext";
import { ZoomMeditocProvider } from "./context/ZoomMeditocContext";
import es from "date-fns/locale/es";
import theme from "./settings/themeConfig";
import { urlBase } from "./settings/urlConfig";

// import ZoomTest from "./ZoomTest";

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter basename={urlBase}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                    <StyleProvider>
                        <LayoutProvider>
                            <TokenProvider>
                                <RequestProvider>
                                    <CatalogoProvider>
                                        <LoginProvider>
                                            <ZoomMeditocProvider>
                                                <UsuarioProvider>
                                                    <PerfilProvider>
                                                        <SistemaProvider>
                                                            <ColaboradorProvider>
                                                                <EmpresaProvider>
                                                                    <ProductoProvider>
                                                                        <CuponProvider>
                                                                            <EspecialidadProvider>
                                                                                <FolioProvider>
                                                                                    <CallCenterProvider>
                                                                                        <AdminConsultaProvider>
                                                                                            <MisConsultasProvider>
                                                                                                <ReporteVentaProvider>
                                                                                                    <ReporteDoctorProvider>
                                                                                                        <AnuncioProvider>
                                                                                                            <MotivoConsultaProvider>
                                                                                                                {/* <ZoomTest /> */}
                                                                                                                <MeditocPage />
                                                                                                            </MotivoConsultaProvider>
                                                                                                        </AnuncioProvider>
                                                                                                    </ReporteDoctorProvider>
                                                                                                </ReporteVentaProvider>
                                                                                            </MisConsultasProvider>
                                                                                        </AdminConsultaProvider>
                                                                                    </CallCenterProvider>
                                                                                </FolioProvider>
                                                                            </EspecialidadProvider>
                                                                        </CuponProvider>
                                                                    </ProductoProvider>
                                                                </EmpresaProvider>
                                                            </ColaboradorProvider>
                                                        </SistemaProvider>
                                                    </PerfilProvider>
                                                </UsuarioProvider>
                                            </ZoomMeditocProvider>
                                        </LoginProvider>
                                    </CatalogoProvider>
                                </RequestProvider>
                            </TokenProvider>
                        </LayoutProvider>
                    </StyleProvider>
                </MuiPickersUtilsProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}
